import Vue from 'vue';

export function s4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

export function uid(): string {
    return s4() + s4() + '_' + s4();
}

export function implementsInterface<T>(object: any, method: string, type?: string): object is T {
    if (type) {
        return typeof (object as T)[method] === type;
    }
    return typeof (object as T)[method] !== 'undefined';
}

/**
 * Convert utf-8 sring to ansi
 * @param str
 * @returns {*}
 */
export function convertUtf8ToAnsi(str: string): string {
    str = str.replace(new RegExp('[∂άαáàâãªäå]', 'g'), 'a');
    str = str.replace(new RegExp('[∆лДΛдАÁÀÂÃÄÅ]', 'g'), 'A');
    str = str.replace(new RegExp('[Æ]', 'g'), 'Ae');
    str = str.replace(new RegExp('[æ]', 'g'), 'ae');
    str = str.replace(new RegExp('[βвВ]', 'g'), 'B');
    str = str.replace(new RegExp('[çς©с]', 'g'), 'c');
    str = str.replace(new RegExp('[δ]', 'g'), 'd');
    str = str.replace(new RegExp('[éèêëέëèεе℮ёєэЭ]', 'g'), 'e');
    str = str.replace(new RegExp('[₣]', 'g'), 'F');
    str = str.replace(new RegExp('[ђћЋ]', 'g'), 'h');
    str = str.replace(new RegExp('[ÍÌÎÏ]', 'g'), 'I');
    str = str.replace(new RegExp('[íìîïιίϊі]', 'g'), 'i');
    str = str.replace(new RegExp('[Јј]', 'g'), 'j');
    str = str.replace(new RegExp('[ΚЌК]', 'g'), 'K');
    str = str.replace(new RegExp('[ќк]', 'g'), 'k');
    str = str.replace(new RegExp('[ℓ∟]', 'g'), 'l');
    str = str.replace(new RegExp('[Мм]', 'g'), 'M');
    str = str.replace(new RegExp('[ñηήηπⁿ]', 'g'), 'n');
    str = str.replace(new RegExp('[Ñ∏пПИЙийΝЛ]', 'g'), 'N');
    str = str.replace(new RegExp('[óòôõºøöοФσόо]', 'g'), 'o');
    str = str.replace(new RegExp('[ÓÒÔÕÖθΩθØОΩ]', 'g'), 'O');
    str = str.replace(new RegExp('[ρφрРф]', 'g'), 'p');
    str = str.replace(new RegExp('[®яЯ]', 'g'), 'R');
    str = str.replace(new RegExp('[ГЃгѓ]', 'g'), 'r');
    str = str.replace(new RegExp('[Ѕ]', 'g'), 'S');
    str = str.replace(new RegExp('[ß]', 'g'), 'Ss');
    str = str.replace(new RegExp('[ẞ]', 'g'), 'ss');
    str = str.replace(new RegExp('[ѕ]', 'g'), 's');
    str = str.replace(new RegExp('[Тт]', 'g'), 'T');
    str = str.replace(new RegExp('[úùûüџμΰµυϋύ]', 'g'), 'u');
    str = str.replace(new RegExp('[√]', 'g'), 'v');
    str = str.replace(new RegExp('[ÚÙÛÜЏЦц]', 'g'), 'U');
    str = str.replace(new RegExp('[Ψψωώẅẃẁщш]', 'g'), 'w');
    str = str.replace(new RegExp('[ẀẄẂШЩ]', 'g'), 'W');
    str = str.replace(new RegExp('[ΧχЖХж]', 'g'), 'x');
    str = str.replace(new RegExp('[ỲΫ¥]', 'g'), 'Y');
    str = str.replace(new RegExp('[ỳγўЎУуч]', 'g'), 'y');
    str = str.replace(new RegExp('[ζ]', 'g'), 'Z');
    return str;
}

export function urlParam(name: string, defaultValue: any = null): any {
    const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return defaultValue;
    }
    return decodeURIComponent(results[1]) || defaultValue;
}


/**
 * iOS safari body scrolling fix
 */
let scrollTop = 0;

export function toggleIOsFix(toggle: boolean = false, transitionSpeed: number = 100) {
    if (toggle) {
        setTimeout(() => {
            scrollTop = document.body.scrollTop;
            document.body.style.position = 'fixed';
        }, transitionSpeed + 25);
    } else {
        document.body.style.position = 'relative';
        document.body.scrollTop = scrollTop;
    }
}

export function isAttachedToDom(element: Node): boolean {
    return document.body.contains(element);
}

export function showPopup(content: string): void {
    Vue.prototype.$modal.show({
        template: `
                <div class="v-modal">
                    <div class="v-modal__close" slot="top-right">
                        <button class="v-modal__close-button" @click="$emit('close')">
                            <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg>
                        </button>
                    </div>
                    <div class="v-modal__content">
                        <div class="clearfix" v-html="content"></div>
                    </div>
                </div>`,
        props: ['content'],
    }, { content }, {
        name: 'content-modal',
        width: 460,
        height: 'auto',
        minHeight: 250,
        adaptive: true,
        pivotY: .25,
    });
}
